

























































































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';

import VueApexCharts from 'vue-apexcharts'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items', 'total', 'graphicList', 'filter', 'payments'
    ]),
    ...mapGetters(STORE_KEY, [
      'byMonthy', 'totalPayments'
    ]),
    ...mapGetters('ubic', [
      'isAdmin', 'isController'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX', 'removeItem'
    ])
  },
  components: {
    TitleBar,
    VueApexCharts
  }
})
export default class MarginalityReport extends Vue {

  cash_file: any = null;
  cashless_file: any = null;
  byMonthy!: any;
  filter!: any;

  modal: any = null;

  checkedRows: any[] = [];

  get titleStack () {
    return [
      'Отчеты',
      'По траспортным/клиентам'
    ]
  }

  localFilter = {
    group_type: "head",
    employees: null,
    clients: null,
    dZoneGroups: null,
    targetDates: [new Date(), new Date()],
    city_id: null,
    head_city_id: null
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'weight', this.$route.query.sortDirection || 'desc']
  }

  get isAccepted() {
    const idx = parseInt(moment(this.$route.query.targetDates[1]).format('MM')) - 1
    console.log(this.localFilter, idx, this.byMonthy)
    return this.byMonthy && this.byMonthy[idx] ? this.byMonthy[idx].is_accepted : false;
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  exportAsXLSX() {
    this.$buefy.snackbar.open(`Начало экспорта данных. Данная процедура может занять некоторое время.`);

    this.$store.dispatch(`${STORE_KEY}/exportDataAsXLSX`, {
      ...this.$route.query
    }).then(() => {
      this.$buefy.snackbar.open(`Экспорт окончен. Файл должен был скачаться на ваш ПК.`);
    }).catch(() => {
      this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
    });
  }


  removeItem(row: any) {
    // @ts-ignore
    const datetime = this.$options.filters.date(row.datetime);
    this.$buefy.dialog.confirm({
      message: `Удалить платеж на сумму ${row.payment} руб. от ${datetime} (клиент: ${row.client_name})?`,
      confirmText: 'Удалить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/removeItem`, row)
        .then((result) => {
          this.$buefy.snackbar.open(`Запись удалена`);
          this.handleParamsChange();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.dZoneGroups = (this.$route.query && this.$route.query.dZoneGroups)? this.$route.query.dZoneGroups : null;
    // @ts-ignore
    this.localFilter.employees = (this.$route.query && this.$route.query.employees)? this.$route.query.employees : null;
    // @ts-ignore
    this.localFilter.clients = (this.$route.query && this.$route.query.clients)? this.$route.query.clients : null;
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];
    // @ts-ignore
    this.localFilter.city_id = (this.$route.query && this.$route.query.city_id)? this.$route.query.city_id : null;
    // @ts-ignore
    this.localFilter.head_city_id = (this.$route.query && this.$route.query.head_city_id)? this.$route.query.head_city_id : null;

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

console.log('query', query)
    this.$router.replace({
      query
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
    this.checkedRows = [];
  }

}
